var map = {
	"./JAICP-hb.svg": 8726,
	"./flags/en.svg": 4597,
	"./flags/ru.svg": 289,
	"./flags/zh.svg": 6190,
	"./icons/collapse-state.svg": 6558,
	"./icons/expand-state.svg": 2199,
	"./icons/incoming-links-collapsed.svg": 3704,
	"./icons/incoming-links.svg": 8714,
	"./icons/lightbulb.svg": 4698,
	"./icons/outgoing-links-collapsed.svg": 7507,
	"./icons/outgoing-links.svg": 1338,
	"./icons/product-menu.svg": 5342,
	"./icons/regular/arrow-to-bottom.svg": 9533,
	"./icons/regular/arrow-to-top.svg": 8469,
	"./icons/regular/cog.svg": 123,
	"./icons/regular/comment-alt-dots.svg": 2142,
	"./icons/regular/comment-plus.svg": 3020,
	"./icons/regular/folder-plus.svg": 1034,
	"./icons/regular/home-lg-alt.svg": 9615,
	"./icons/regular/link.svg": 9254,
	"./icons/regular/minus-circle.svg": 5383,
	"./icons/regular/pen.svg": 8813,
	"./icons/regular/plus.svg": 6764,
	"./icons/regular/repeat.svg": 3542,
	"./icons/regular/sign-in-alt.svg": 1071,
	"./icons/regular/sparkles.svg": 5626,
	"./icons/regular/sticky-note.svg": 5061,
	"./icons/regular/text.svg": 38,
	"./icons/solid/bolt.svg": 1134,
	"./icons/solid/code.svg": 2108,
	"./icons/solid/project-diagram.svg": 4011,
	"./icons/tag-with-plus.svg": 1761,
	"./icons/target.svg": 7940,
	"./jaicp-favicon.ico": 1127,
	"./jaicp_black_h.svg": 8704,
	"./main-page/about1.svg": 9163,
	"./main-page/about2.svg": 3404,
	"./main-page/about3.svg": 743,
	"./main-page/link1.svg": 4391,
	"./main-page/link2.svg": 3113,
	"./main-page/link3.svg": 1322,
	"./main-page/link4.svg": 4195,
	"./main-page/rocket.svg": 8212,
	"./page-404.svg": 8285,
	"./platform-b.svg": 3409,
	"./platform-favicon.ico": 9354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7165;